import { useState } from 'react';
import { useUserState } from '../../hooks/context/useUserState';
import useApiErrorHandling from '../../hooks/useApiErrorHandling';
import { ReportDataResponseBody } from '../types/generated/report_data_post.response';
import { ReportDataContentBody } from '../types/generated/report_data_post.content';
import { requestReportData } from '../requests/reports/requestReportData';

export const useReportData = (id: string) => {
  const {
    state: { token },
  } = useUserState();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);
  const [data, setData] = useState<ReportDataResponseBody | undefined>(
    undefined
  );
  const handleApiError = useApiErrorHandling();

  const fetch = async (body: ReportDataContentBody, forceHeader?: string) => {
    let reportData;
    try {
      setIsLoading(true);
      setData(undefined);
      setError(undefined);
      reportData = await requestReportData(id, body, token, forceHeader);
      setData(reportData);
    } catch (e) {
      if (e instanceof Error) setError(e);
      handleApiError(e, true, (forceHeader) => fetch(body, forceHeader));
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    error,
    data,
    fetch,
  };
};
